export default __webpack_public_path__ + "static/media/mission.c4bbfe1d.png";